import * as React from 'react';
import type { SVGProps } from 'react';

const SvgToday = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      transform="translate(1 1)"
    >
      <rect width={20} height={20} rx={2.18} />
      <path d="M4 8h12v4H4zM16 15.5H9M6 15.5H4M4 4.5h7M14 4.5h2" />
    </g>
  </svg>
);
export default SvgToday;
